import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDashStats } from '../services/api';

export default function Dashboard() {
  const { data, isLoading } = useQuery({ queryKey:['dash'], queryFn:()=>getDashStats().then(r=>r.data.data) });
  if (isLoading) return <div className="loading-center"><div className="spinner"/></div>;
  if (!data) return null;
  return (
    <div>
      <div className="g4" style={{marginBottom:20}}>
        <div className="card-sm"><div className="stat-label">Total Clients</div><div className="stat-val">{data.totalClients}</div></div>
        <div className="card-sm"><div className="stat-label">Active Projects</div><div className="stat-val">{data.activeProjects}</div></div>
        <div className="card-sm"><div className="stat-label">Revenue (KWD)</div><div className="stat-val" style={{color:'var(--green)'}}>KWD {parseFloat(data.revenue).toLocaleString()}</div></div>
        <div className="card-sm"><div className="stat-label">Outstanding (KWD)</div><div className="stat-val" style={{color:'var(--warn)'}}>KWD {parseFloat(data.outstanding).toLocaleString()}</div></div>
      </div>
      <div className="g4" style={{marginBottom:20}}>
        <div className="card-sm"><div className="stat-label">Pipeline Value</div><div className="stat-val">KWD {parseFloat(data.pipelineValue).toLocaleString()}</div></div>
        <div className="card-sm"><div className="stat-label">Won Leads</div><div className="stat-val" style={{color:'var(--green)'}}>{data.wonLeads}</div></div>
        <div className="card-sm"><div className="stat-label">Active Subscriptions</div><div className="stat-val">{data.activeSubscriptions}</div></div>
        <div className="card-sm"><div className="stat-label">Servers Expiring</div><div className="stat-val" style={{color:data.expiringServers>0?'var(--warn)':undefined}}>{data.expiringServers}</div></div>
      </div>
      <div className="card">
        <div className="form-section-title">Leads Pipeline</div>
        {data.leadsByStatus.map(l=>(
          <div key={l.status} style={{marginBottom:12}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
              <span style={{fontSize:12,color:'var(--muted)'}}>{l.status}</span>
              <span style={{fontSize:12,fontWeight:500}}>{l.count}</span>
            </div>
            <div className="prog-bar"><div className="prog-fill" style={{width:Math.round(l.count/Math.max(...data.leadsByStatus.map(x=>x.count),1)*100)+'%',background:'var(--green)'}}/></div>
          </div>
        ))}
      </div>
    </div>
  );
}
